/*
 * @Author: libo 
 * @Date: 2020-11-13 17:13:51 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-04-13 13:59:00
 */

<!--收费项目新增界面-->
<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail" :colon="false" layout="vertical">
        <a-row :gutter="16">
          <!-- <a-col :span="12">
            <a-form-item has-feedback label="收费编码">
              <a-input :disabled="disabled||isUsed" v-decorator="['priceId',validatorRules.priceId]" placeholder="请输入收费Id"></a-input>
            </a-form-item>
          </a-col> -->
          <a-col :span="12">
            <a-form-item has-feedback :label="$t('收费名称')">
              <a-input :disabled="disabled||isUsed" v-decorator="['priceName',validatorRules.priceName]" :placeholder="$t('请输入收费名称')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('收费方式')">
              <a-select :disabled="disabled||isUsed" v-decorator="['priceWay',validatorRules.priceWay]" :placeholder="$t('请输入收费方式')">
                <a-select-option :value="1">
                  {{ $t('按量收取') }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('收费类型')">
              <a-input :disabled="disabled||isUsed" v-decorator="['priceType',validatorRules.priceType]" :placeholder="$t('请输入收费类型')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('收费价格')">
              <a-input :disabled="disabled||isUsed" v-decorator="['price',validatorRules.price]" :placeholder="$t('请输入收费价格')" :step="0.01" :suffix="$t('元/吨')" style="width:100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('收取违约金')">
              <j-dict-select-tag :disabled="disabled||isUsed" v-decorator="['hasPenalty', validatorRules.hasPenalty]" :triggerChange="true" :placeholder="$t('请选择是否收取违约金')" dictCode="yn" style="width:100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('计算公式')">
              <a-input :disabled="disabled||isUsed" v-decorator="['priceItemFormula',validatorRules.priceItemFormula]" :placeholder="$t('请输入计算公式')" style="width:100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('备注')">
              <a-textarea :disabled="disabled" v-decorator="['priceRemark']" rows="3" :placeholder="$t('请输入备注')" />
            </a-form-item>
          </a-col>
          </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>
<script>
  import { httpAction,getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import {isUndefined} from'@/utils/validate'
  import { mapGetters } from 'vuex'
  export default {
    name: 'MeterPriceItemForm',
    components: {
      JFormContainer,
    },
    props: {
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        confirmLoading: false,
        url: {
          add: "/jeecg-charge/meter/meterPriceItem/add",
          edit: "/jeecg-charge/meter/meterPriceItem/edit",
          queryById: "/jeecg-charge/meter/meterPriceItem/queryById",
          queryPricecItemByUserId: "/jeecg-charge/meter/meterPriceItem/list"
        },
        isUsed: false,
      }
    },
    computed: {
      // i18n：校验消息使用 computed 以响应语言切换
      validatorRules() {
        return {
          priceName:{ //收费名称
            rules:[
              {required: true, message: this.$t('请输入收费名称！')},
              {validator: this.validatePriceName}
            ]
          },
          priceWay:{  //收费方式
            initialValue:1,
            rules:[
              {required: true, message: this.$t('请输入收费方式！')}
            ]
          },
          priceType:{  //收费类型
            rules:[
              {required: true, message: this.$t('请输入收费类型！')}
            ]
          },
          price:{  //收费价格
            rules:[
              {required: true, message: this.$t('请输入收费价格！')},
              {pattern: /^(([1-9]\d*)(\.\d{1,2})?|0\.([1-9]|\d[1-9])|0)$/,message: this.$t('收费价格有误，请输入2位的小数')},
              {validator: this.validatePrice}
            ]
          },
          hasPenalty:{  //是否收取违约金
            rules:[
              {required: true, message: this.$t('请选择是否收取违约金！')}
            ]
          },
        }
      },
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
    },
    methods: {
      ...mapGetters(["userInfo"]),
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        console.log(!!this.model.id);
        if (!!this.model.id) {
        this.model.price = record.price/100;  //收费价格
        }
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'priceId','priceName','priceWay','priceType','price','hasPenalty','priceRemark','priceItemFormula'))
        })
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            formData.price = this.model.price*100
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'priceId','priceName','priceWay','priceType','price','hasPenalty','priceRemark','createTime','createBy','priceItemFormula'))
      },
      validatePriceId(rule, value, callback){
        if(isUndefined(value)||value == "") {
          callback("")
          return
        }
        let org = this.userInfo().orgCode
        let priceId = this.form.getFieldValue('priceId').trim();
        this.form.setFieldsValue({priceId: priceId});
        let params = {priceId: priceId,sysOrgCode: org}
        getAction(this.url.queryPricecItemByUserId,params).then((res) => {
          if (res.success&&res.result.records.length>0) {
            if(this.model.id&&res.result.records[0].id === this.model.id) {
              callback()
            }else{
              callback(this.$t("该价格编号已存在!"))
            }
          } else {
            callback()
          }
        })
      },
      validatePriceName(rule, value, callback){
        if(isUndefined(value)||value == "") {
          callback("")
          return
        }
        let org = this.userInfo().orgCode
        let priceName = this.form.getFieldValue('priceName').trim();
        this.form.setFieldsValue({priceName: priceName});
        let params = {priceName: priceName,sysOrgCode: org}
        getAction(this.url.queryPricecItemByUserId,params).then((res) => {
          if (res.success&&res.result.records.length>0) {
            if(this.model.id&&res.result.records[0].id === this.model.id) {
              callback()
            }else{
              callback(this.$t('该价格名称已存在!'))
            }
          } else {
            callback()
          }
        })
      },
      validatePrice(rule, value, callback) {
        if(isUndefined(value)||value=== '') {
          callback()
          return
        }
        if(parseFloat(value)>600) {
          callback(this.$t('收费价格不能超过600!'))
        }
        callback()
      },
    }
  }
</script>